import React from "react";
import {
  Typography,
  Divider,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Box,
} from "@mui/material";
import { PriceResponse } from "../models/priceResponse.ts";

interface Props {
  label: string;
  calculation: PriceResponse | null | undefined;
  numberOfSystems: number;
  setNumberOfSystems: (value: number) => void;
}

const PriceResponseView: React.FC<Props> = ({
  label,
  calculation,
  numberOfSystems,
  setNumberOfSystems,
}) => {
  return (
    <>
      <Typography variant="h6">{label}</Typography>
      <Divider sx={{ my: 1 }} />
      <TableContainer component={Paper} elevation={1}>
        <Table aria-label={label}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "10%" }}>
                <strong>Pos.</strong>
              </TableCell>
              <TableCell sx={{ width: "40%" }}>
                <strong>Bezeichnung</strong>
              </TableCell>
              <TableCell sx={{ width: "15%" }}>
                <strong>Anzahl</strong>
              </TableCell>
              <TableCell sx={{ width: "15%" }}>
                <strong>Betrag</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {calculation?.positions.map((pos, index) => (
              <TableRow key={`${index}-${pos.label}`}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{pos.label}</TableCell>
                <TableCell>{pos.number}</TableCell>
                <TableCell>{pos.amount.toFixed(2)} €</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell />
              <TableCell colSpan={2}>
                <strong>Einzelpreis</strong>
              </TableCell>
              <TableCell>{calculation?.unit_price.toFixed(2)} €</TableCell>
            </TableRow>
          </TableBody>
          <Box mt={2} />
          <TableBody>
            <TableRow>
              <TableCell />
              <TableCell>
                <strong>Gesamtpreis</strong>
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  value={numberOfSystems}
                  onChange={(e) => setNumberOfSystems(Number(e.target.value))}
                  inputProps={{ min: 1 }}
                  size="small"
                />
              </TableCell>
              <TableCell>
                {calculation?.total_price.toFixed(2)} €
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PriceResponseView;